import { kymw7400Handlers } from "./kymw7400-handlers";
import { kymw7401Handlers } from "./kymw7401-handlers";
import { kymw7402Handlers } from "./kymw7402-handlers";
import { kymw7403Handlers } from "./kymw7403-handlers";

export const kymw74Handlers = [
  ...kymw7400Handlers,
  ...kymw7401Handlers,
  ...kymw7402Handlers,
  ...kymw7403Handlers,
];
